import { render } from "./XmlMapperHeadList.vue?vue&type=template&id=510902fe&scoped=true&ts=true"
import script from "./XmlMapperHeadList.vue?vue&type=script&lang=ts"
export * from "./XmlMapperHeadList.vue?vue&type=script&lang=ts"

import "./XmlMapperHeadList.vue?vue&type=style&index=0&id=510902fe&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510902fe"]])

export default __exports__